/** Stub — query parser for natural language route requests */

export interface RoutePreferences {
  distance?: number;
  terrain?: string;
  avoidTraffic?: boolean;
  preferParks?: boolean;
  maxAqi?: number;
  raw: string;
}

export const EXAMPLE_QUERIES = [
  'Find me a 5k route with clean air',
  'Plan a 10k avoiding busy roads',
  'Short run through parks, low pollution',
];

export function parseRouteQuery(query: string): RoutePreferences {
  const prefs: RoutePreferences = { raw: query };

  const distMatch = query.match(/(\d+)\s*(k|km|mi)/i);
  if (distMatch) {
    prefs.distance = parseInt(distMatch[1]) * (distMatch[2].toLowerCase().startsWith('mi') ? 1.6 : 1);
  }

  if (/park|green|nature/i.test(query)) prefs.preferParks = true;
  if (/avoid.*(traffic|road|busy)/i.test(query)) prefs.avoidTraffic = true;
  if (/clean|low.*(aqi|pollution)/i.test(query)) prefs.maxAqi = 50;

  return prefs;
}

export function summarizePreferences(prefs: RoutePreferences): string {
  const parts: string[] = [];
  if (prefs.distance) parts.push(`${prefs.distance}km`);
  if (prefs.preferParks) parts.push('through parks');
  if (prefs.avoidTraffic) parts.push('avoiding traffic');
  if (prefs.maxAqi) parts.push(`AQI < ${prefs.maxAqi}`);
  return parts.length > 0 ? parts.join(', ') : 'Any route';
}
